import { useEffect, useState } from 'react';
import { CURATOR_EVENTS } from '@noths/polaris-client-site-chrome-ui';

/**
 * Hook to manage Curator state and event handling.
 * Listens for 'TOGGLE_CURATOR' custom events dispatched by the header component.
 */
export const useCurator = () => {
  const [isCuratorOpen, setIsCuratorOpen] = useState(false);

  useEffect(() => {
    const handleToggleCurator = () => {
      setIsCuratorOpen((prev) => !prev);
    };

    document.addEventListener(CURATOR_EVENTS.TOGGLE_CURATOR, handleToggleCurator);

    return () => {
      document.removeEventListener(CURATOR_EVENTS.TOGGLE_CURATOR, handleToggleCurator);
    };
  }, []);

  const handleToggle = () => {
    // Toggle curator when user interacts with curator itself (e.g., close button)
    document.dispatchEvent(new CustomEvent(CURATOR_EVENTS.TOGGLE_CURATOR));
  };

  return {
    isCuratorOpen,
    handleToggle,
  };
};
